export * from './lib/ng-material.module';
